module.exports = __webpack_public_path__ + "static/media/2-ask_first.493f073a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/2-ask_first.pdf
// module id = 156
// module chunks = 0